import React from "react"
import styles from "../../../styles/global.module.scss"
import NavigationItem from "./navigation_item"

export default function SubNavItems({ nav_item, selected_tab, all_pages }) {
  const { sub_items } = nav_item

  // Check if selected nav item = to this parent nav item
  // If true, show sub nav
  let tab_name, sub_menu_active
  // If label, set nav_item name to label, else set to page name
  nav_item.label ? (tab_name = nav_item.label) : (tab_name = nav_item.page)
  selected_tab === tab_name
    ? (sub_menu_active = true)
    : (sub_menu_active = false)

  if (!sub_items) {
    return null
  }

  return (
    <div
      className={`${styles.subNav} ${
        sub_menu_active ? styles.subNavActive : null
      }`}
    >
      <ul>
        {sub_items.map((item, i) => {
          if (all_pages) {
            let page_name = all_pages.edges.find(
              p => p.node.frontmatter.page_id === item.sub_item.page_id
            )
            if (page_name) {
              item.sub_item.page = page_name.node.frontmatter.title
            }
          }
          return (
            <li key={i}>
              <NavigationItem nav_item={item.sub_item} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
